export default __webpack_public_path__ + "static/media/footer-img.ead4c0d3.png";